import React, { useEffect } from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

/**
 * Standard page title + subtitle with an optional left Back button and a
 * right-aligned action area. Also keeps the browser tab title in sync with the
 * current page (falls back to `docTitle` when `title` is a React node).
 */
const PageHeader = ({ title, subtitle, extra, onBack, docTitle }) => {
  useEffect(() => {
    const t = docTitle || (typeof title === 'string' ? title : null);
    document.title = t ? `${t} · VelorHR Administration` : 'VelorHR Administration';
    return () => {
      document.title = 'VelorHR Administration';
    };
  }, [title, docTitle]);

  return (
    <div className="page-header">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {onBack ? (
          <Button icon={<ArrowLeftOutlined />} onClick={onBack} aria-label="Back" />
        ) : null}
        <div>
          <h2>{title}</h2>
          {subtitle ? <div className="sub">{subtitle}</div> : null}
        </div>
      </div>
      {extra ? <div>{extra}</div> : null}
    </div>
  );
};

export default PageHeader;
